import { render, staticRenderFns } from "./Pickup-Address.vue?vue&type=template&id=0825245c"
import script from "./Pickup-Address.vue?vue&type=script&lang=js"
export * from "./Pickup-Address.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports